import { render, staticRenderFns } from "./product_5_sjg.vue?vue&type=template&id=353c0b9f&scoped=true"
import script from "./product_5_sjg.vue?vue&type=script&lang=js"
export * from "./product_5_sjg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353c0b9f",
  null
  
)

export default component.exports